<template>
    <v-menu
        v-model="editing"
        transition="scale-transition"
        :close-on-content-click="false"
        :nudge-width="100"
        :disabled="!allowEditing"
    >
        <template v-slot:activator="{ on }">
            <a class="blue-grey--text text--darken-2" v-on="on">
                <label-user :value="issue.assignedTo" :avatar="false" :size="24" />
            </a>
        </template>
        <v-card>
            <v-card-text>
                <selector-user
                    v-model="editingValue"
                    :creator="issue.createdBy"
                    :allow-remove="member.roles.includes('productManager')"
                />
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="editing = false" v-text="$t('buttons.cancel')" />
                <v-btn color="success" text @click="changeAttribute" v-text="$t('buttons.save')" />
            </v-card-actions>
        </v-card>
    </v-menu>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { projectMemberMixin } from '@/mixins/member';
import selectorUser from '@/components/selectors/simple/userProject';
import labelUser from '@/components/labels/user';
export default {
    name: 'issue-assignedTo',
    data: () => ({
        editing: false,
        editingValue: undefined,
    }),
    mixins: [projectMemberMixin],
    props: {
        issue: {},
        displayValue: {
            default: false,
        },
        allowEditing: {
            default: true,
        },
        onlyEdit: {
            default: false,
        },
    },
    components: { selectorUser, labelUser },
    watch: {
        editing: function (e) {
            if (e) {
                this.editingValue = this.issue.assignedTo;
            }
        },
    },
    computed: {
        ...mapGetters(['project']),
    },
    methods: {
        ...mapActions(['updateIssue']),
        async changeAttribute(value) {
            if (this.onlyEdit) {
                this.$emit('update-attribute', { name: 'assignedTo', value: this.editingValue });
                this.editing = false;
            } else {
                await this.updateIssue({
                    id: this.issue.id,
                    assignedTo: this.editingValue,
                });

                this.editing = false;
                this.$emit('change-attribute-value');
            }
        },
    },
};
</script>
